const currentYear = new Date().getFullYear();

const COMPLETION_DATE = {

  id: "completion_date",
  type: "dropdown",
  props: {
    isMulti: true,
    dropdownProps: {
      label: "TOP",
      buttonProps: {
        className: "completion_date",
      },
      menuProps: {
        style: {
          // minWidth: 300
        }
      }
    },
    options: [...Array(6).keys()].map(item => {
      const year = currentYear + item;
      if (year === currentYear) {
        return { label: "Completed", value: "Completed" };
      }
      return { label: year.toString(), value: year.toString() };
    })
  }

}

const COL_COMPLETION_DATE = {

  id: "col_completion_date",
  type: "col",
  props: {
    lg: 3,
    md: 4,
    xs: 6,
  },
  children: [COMPLETION_DATE]

}

const COL_MODAL_COMPLETION_DATE = {

  id: "col_completion_date",
  type: "col",
  props: {
    lg: 6,
    md: 6,
    xs: 6,
  },
  children: [COMPLETION_DATE]

}

export { COMPLETION_DATE, COL_COMPLETION_DATE, COL_MODAL_COMPLETION_DATE };
